import { Container } from "@mui/material";

const NotFound = () => {
 return (
  <Container sx={{ textAlign: "center", marginTop: "20px" }}>
   <h1>Page Not Found</h1>
  </Container>
 );
};

export default NotFound;
